import { ArrowRight, ChevronRight } from 'lucide-react';
import { getAthenaUrl } from '../config/platformUrls';

interface RedirectToAthenaProps {
  isFreeUser?: boolean;
}

export default function RedirectToAthena({ isFreeUser = false }: RedirectToAthenaProps) {
  if (isFreeUser) {
    // Marketing-style page for free users
    return (
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center py-16">
          {/* Subtle redirect notice */}
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Oops — you've reached our legacy weather platform. Checkout our new and improved
            platform, Athena.
          </p>

          {/* Bold Headline */}
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-6 leading-tight">
            Meet Athena. Your AI analyst for energy trading.
          </h1>

          {/* Description */}
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-10 leading-relaxed max-w-2xl mx-auto">
            Ask anything about weather, markets, and positions. Get answers in seconds, not hours.
            Powered by the world's leading EPT-2 weather model.
          </p>

          {/* Action Button */}
          <div className="flex justify-center">
            <a
              href={getAthenaUrl()}
              className="inline-flex items-center px-8 py-4 text-lg font-semibold rounded-full bg-gray-900 dark:bg-white text-white dark:text-gray-900 hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors duration-200"
              data-ph-capture-attribute="btn-try-athena"
            >
              Try Athena
              <ChevronRight className="w-5 h-5 ml-1" />
            </a>
          </div>
        </div>
      </div>
    );
  }

  // Simple redirect page for subscriber:tier users
  return (
    <div className="max-w-2xl mx-auto px-4">
      <div className="text-center py-12">
        {/* Icon */}
        <div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-[#E34290]/10 dark:bg-[#E34290]/20 mb-6">
          <ArrowRight className="w-8 h-8 text-[#E34290]" />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          Oops! You've landed on the old dashboard
        </h1>

        {/* Description */}
        <p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
          Your subscription is for Athena, our new and improved platform.
          <br />
          Head over there to access your weather data.
        </p>

        {/* Action Button */}
        <div className="flex justify-center">
          <a
            href={getAthenaUrl()}
            className="inline-flex items-center px-6 py-3 text-base font-medium rounded-lg bg-[#E34290] text-white hover:text-white hover:bg-[#c9357a] transition-colors duration-200"
            data-ph-capture-attribute="btn-redirect-to-athena"
          >
            Go to Athena
            <ArrowRight className="w-4 h-4 ml-2" />
          </a>
        </div>
      </div>
    </div>
  );
}
